import React, {PropTypes} from "react"
import {Link} from "react-router"
import {Col, Button} from "elemental"
import ButtonLove from "../Button/ButtonLove"
import shop from "../../shop/shop"
import "./ProductCol5.scss"

import Badge from "./Badge"

import Price from "../Price/Price"

const ProductCol5 = ({ product }) => {
  const hasRabatt = product.pinfos && product.pinfos.zuab !== "0"
  return (
    <Col xs="1/2"
         sm="1/3"
         md="1/4"
         lg="1/5"
         className="product product-col5">
      <Link to={`/product/${product.map_id}`} className="product-box">
        <div className="product-inner">
          <Badge product={product}/>
          <div className="image tc">
            <img src={product.img_src}
                 alt="..."
                 title=""
                 className="img-responsive"/>
          </div>
          <div className="caption">
            <div className="article-nr black">{product.article_nr}</div>
            <div className="title">{product.desc.short_des}</div>

            {shop.session && <div className="price-container">
              {hasRabatt && <div><Price className="fw2 f5 strike">{product.pinfos.brutto}</Price></div>}
              <Price className={`price ${hasRabatt && "red"}`}>{product.price}</Price>
            </div>}
          </div>
        </div>
      </Link>

      {shop.session && <div className="cb overflow-hidden">
        <ButtonLove
          className="fl"
          list={shop.orderlist.default}
          elementInActive={<Button><i className="icon icon-heart-empty"/></Button>}
          elementActive={<Button><i className="icon icon-heart"/></Button>}
          product={product}/>

        <Button className="fr"
                onClick={() => {
                  product.count = 1
                  shop.cart.add( product )
                }}> <i className="icon icon-basket"/> </Button>
      </div>
      }

      {/*<div className="button-group">*/}
      {/*<button className="btn-primary" type="button"><span>ADD TO CART</span></button>*/}
      {/*<div className="add-to-links">*/}
      {/*<button type="button" data-toggle="tooltip" title=""*/}
      {/*data-original-title="Add to Wish List"><i className="fa fa-heart"></i>*/}
      {/*<span>Add to Wish List</span></button>*/}
      {/*</div>*/}
      {/*</div>*/}
    </Col>
  )
}

ProductCol5.propTypes = {
  product: PropTypes.object
}

export default ProductCol5



// WEBPACK FOOTER //
// ./src/components/Product/ProductCol5.js